<template>
  <div class="c-record-cp">
    <!-- filter -->
    <record-cp-filter
      :games="gameData"
      @on-down="downExcel"
      @on-import="importExcel"
      @on-set="addRecord"
      @on-change="filterData"
      @on-search="searchFilterData"
    />
    <!-- table -->
    <div class="c-table-list">
      <Viewport v-model="tableHeight" v-loading="loading">
        <record-cp-table
          :height="tableHeight"
          :data="tableList"
          :columns="tableCol"
          @on-edit="addRecord"
          @on-del="delRecord"
          @on-refresh="getData"
        />
        <el-pagination
          :total="total"
          :current-page.sync="pageIndex"
          :page-size="pageSize"
          :page-sizes="[10, 20, 30, 40, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          @current-change="changePageIndex"
          @size-change="changePageSize"
          class="c-table-page pager"
          background
        />
      </Viewport>
    </div>
    <set-record v-model="model" title="CP分成" :loading="loading" :edit="edit" :info="info" :games="gameData" @on-save="saveRecord" />

    <resulter
      v-model="resultModel"
      type="CP分成"
      :add-total="added"
      :update-total="updated"
      :fail-total="failure"
      :req="req_id"
      @on-close="resultOk"
      @on-down="downFailExecl"
    />
  </div>
</template>
<script>
import mixin from '../mixins/mixin'
import columns from '../data/record_cp_column'
import { setLocal, getLocal, div, mul } from '@/common/js/api'
import { isArray, isEmpty } from '@/common/js/utils'
import { HOST_API } from '@/api/config'
import { getPtomGroupGames } from '@/api/material.model'
import { getGZRecordCPList, delGZRecordCP, setGZRecordCP, getGZRecordCP, importCPExcel } from '@/api/manage.model'
import RecordCpFilter from './components/record-cp-filter'
import RecordCpTable from './components/record-cp-table'
import SetRecord from './components/set-record'
import Resulter from './components/result-dialog'

export default {
  name: 'recordCp',
  mixins: [mixin],
  components: { RecordCpFilter, RecordCpTable, SetRecord, Resulter },
  methods: {
    getData(filter) {
      let params = {
        page_id: this.pageIndex,
        page_size: this.pageSize
      }
      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      this.params = JSON.parse(JSON.stringify(params))
      this.loading = true
      getGZRecordCPList(params)
        .then((data) => {
          this.loading = false
          if (data) {
            const { list, page_info } = data
            if (isArray(list) && page_info) {
              const { total_number } = page_info
              this.total = total_number || 0
              this.tableList = list.map((ret) => {
                return ret
              })
            }
          }
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    setLocalPage(size) {
      setLocal('RECORD_CP_PAGESIZE', size)
    },
    addRecord(edit) {
      this.edit = !!edit
      if (edit) {
        const { reportMonth, gameId } = edit
        this.loading = true
        getGZRecordCP({
          reportMonth: reportMonth,
          gameId
        }).then((data) => {
          this.loading = false
          if (data) {
            const { reportMonth, gameId, cpRate } = data
            this.info = {
              gameId,
              month: reportMonth,
              divide: mul(cpRate, 100)
            }
            // 打开弹窗
            this.model = true
          }
        })
      } else {
        this.info = Object.assign(this.info, {
          gameId: '',
          month: '',
          divide: ''
        })
        this.model = true
      }
    },
    saveRecord(params) {
      const { gameId, month, divide } = params
      const fixedDivide = parseFloat(divide) > 0 ? div(divide, 100) : 0
      const { err, msg } = this.vaild({ gameId, month, divide: fixedDivide })
      if (err) {
        this.$Message.error({
          duration: 5,
          content: msg
        })
        return
      }
      this.loading = true
      setGZRecordCP({
        reportMonth: month,
        gameId,
        cpRate: fixedDivide
      }).then((data) => {
        this.loading = false
        if (data) {
          !this.edit && (this.pageIndex = 1)
          this.getData()
          this.model = false
        }
      })
    },
    delRecord(row) {
      const { reportMonth, gameId } = row
      delGZRecordCP({
        reportMonth,
        gameId
      }).then((data) => {
        if (data) {
          this.getData()
        }
      })
    },
    vaild(params) {
      const keys = Object.keys(params)
      const value = { gameId: '游戏', month: '月份', divide: 'CP分成比例' }
      let err = false
      let msg = ''

      keys.some((ret) => {
        if (!isEmpty(params[ret])) {
          if (ret === 'divide' && (params[ret] > 1 || params[ret] <= 0)) {
            msg = `${value[ret]}0.01-100的数值，最多2位小数`
            err = true
            return false
          }
        } else {
          msg = `${value[ret]}不能为空`
          err = true
          return false
        }
      })

      return { err, msg }
    },
    downExcel() {
      window.open(`${HOST_API}/api/ptom/template/downTemplate?templateType=template_guangz_cp_rate`, '_blank')
    },
    downFailExecl(req) {
      window.open(`${HOST_API}/api/ptom/guangzCpRateSet/downloadImportResult?requestId=${req}`)
    },
    importExcel(file) {
      this.$Spin.show()
      importCPExcel({ file }).then((data) => {
        this.$Spin.hide()
        if (data) {
          this.resultModel = true
          this.added = data.addTotal
          this.failure = data.failTotal
          this.updated = data.updateTotal
          this.req_id = data.requestId
        }
      })
    },
    resultOk() {
      this.resultModel = false
      this.getData()
    },
    proloadData() {
      getPtomGroupGames()
        .then((data) => {
          if (isArray(data)) {
            this.gameData = data.map((ret) => {
              return {
                id: ret.groupId,
                name: ret.groupName
              }
            })
          }
          this.getData({})
        })
        .catch((error) => {
          this.$Message.error({
            duration: 5,
            content: error
          })
        })
    }
  },
  created() {
    this.pageSize = parseInt(getLocal('RECORD_CP_PAGESIZE')) || 20
    this.tableCol = columns
    this.proloadData()
  },
  data() {
    return {
      tableHeight: 330,
      model: null,
      loading: null,
      info: {},
      edit: null,
      gameData: [],

      resultModel: null,
      added: 0,
      failure: 0,
      updated: 0,
      req_id: ''
    }
  }
}
</script>
<style lang="scss" scoped>
.c-table-page {
  padding: 5px 0;
  text-align: right;
}
</style>
